import type { RedactRound } from "./redact.ts";

export const NOTANY_REDACT_DECK_EL: readonly RedactRound[] = [
  {
    context:
      "Ένα πρόχειρο που πρόκειται να επικολλήσετε σε ένα δημόσιο εργαλείο AI. Διορθώστε τι δεν πρέπει να αφήσει:",
    tokens: [
      {
        text: "Συνοψίστε αυτόν τον λογαριασμό",
        sensitive: false,
        conceptId: "self_hosted",
      },
      {
        text: "για την πελάτισσα Jane Okafor",
        sensitive: true,
        conceptId: "privacy_first",
      },
      {
        text: "λογαριασμός 4471-8820",
        sensitive: true,
        conceptId: "privacy_first",
      },
      {
        text: "και τον ακυκλοφόρητο οδικό μας χάρτη για το τρίτο τρίμηνο",
        sensitive: true,
        conceptId: "self_hosted",
      },
      {
        text: "σε τρία σημεία.",
        sensitive: false,
        conceptId: "self_hosted",
      },
    ],
  },
  {
    context:
      "Το μάθημα εμφανίστηκε μετά τον γύρο — με τον notanyai να φιλοξενείται μόνος του, αυτό είναι αμφιλεγόμενο:",
    tokens: [
      {
        text: "Επειδή το μοντέλο τρέχει στο δικό σας περιβάλλον,",
        sensitive: false,
        conceptId: "self_hosted",
      },
      {
        text: "αυτά τα δεδομένα δεν έπρεπε ποτέ να φύγουν από την περίμετρό σας",
        sensitive: false,
        conceptId: "self_hosted",
      },
      {
        text: "στην πρώτη θέση.",
        sensitive: false,
        conceptId: "self_hosted",
      },
    ],
  },
  {
    context: "Εσωτερική σημείωση σχετικά με τα μαθήματα κατάρτισης που θα αποσταλούν:",
    tokens: [
      {
        text: "Ίδιος κινητήρας, τα δικά μας SubjectPacks:",
        sensitive: false,
        conceptId: "your_content",
      },
      {
        text: "ενσωμάτωση, ασφάλεια, συμμόρφωση.",
        sensitive: false,
        conceptId: "your_content",
      },
      {
        text: "Κανένα περιεχόμενο δεν φεύγει από την εταιρεία.",
        sensitive: false,
        conceptId: "self_hosted",
      },
    ],
  },
  {
    context:
      "Ένας συμπαίκτης επικολλά μια μεταγραφή υποστήριξης για να «λάβει βοήθεια για τη διατύπωση μιας απάντησης»:",
    tokens: [
      {
        text: "Απαντήστε ευγενικά σε αυτό το εισιτήριο:",
        sensitive: false,
        conceptId: "privacy_first",
      },
      {
        text: "email χρήστη j.okafor@acme.com",
        sensitive: true,
        conceptId: "privacy_first",
      },
      {
        text: "διεύθυνση κατοικίας 742 Evergreen Terrace",
        sensitive: true,
        conceptId: "privacy_first",
      },
      {
        text: "ζητώντας επιστροφή χρημάτων.",
        sensitive: false,
        conceptId: "privacy_first",
      },
    ],
  },
  {
    context: "Κάρτα υπενθύμισης απορρήτου για την ομάδα:",
    tokens: [
      {
        text: "Οι διαγραμμένοι λογαριασμοί είναι ανώνυμοι,",
        sensitive: false,
        conceptId: "privacy_first",
      },
      {
        text: "δεν διατηρούνται αναγνωρίσιμα.",
        sensitive: false,
        conceptId: "privacy_first",
      },
      {
        text: "Η ασφάλεια σε επίπεδο σειράς απομονώνει κάθε μαθητή.",
        sensitive: false,
        conceptId: "privacy_first",
      },
    ],
  },
  {
    context: "Μήνυμα για την προμήθεια σχετικά με τη φιλοξενία:",
    tokens: [
      {
        text: "Ολόκληρη η στοίβα τρέχει στο δικό μας σύννεφο:",
        sensitive: false,
        conceptId: "self_hosted",
      },
      {
        text: "ένα στατικό πακέτο συν ένα ανοιχτό backend",
        sensitive: false,
        conceptId: "self_hosted",
      },
      {
        text: "σε ένα μικρό VM.",
        sensitive: false,
        conceptId: "self_hosted",
      },
    ],
  },
] as const;
